import { render, staticRenderFns } from "./ToggleBold.vue?vue&type=template&id=404982c1&scoped=true&"
import script from "./ToggleBold.vue?vue&type=script&lang=js&"
export * from "./ToggleBold.vue?vue&type=script&lang=js&"
import style0 from "./ToggleBold.vue?vue&type=style&index=0&id=404982c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404982c1",
  null
  
)

export default component.exports